import type { IComponentController, IScope, IWindowService } from "angular";

import type { IFormContainerResolve } from "App/Modules/Services";
import type { IConfig } from "App/Modules/Utils";

export class UnauthorizedModalComponentController implements IComponentController {
    public static $inject = ["$scope", "$window", "irConfig"];

    public resolve: IFormContainerResolve<null, null>;

    public customerAppUrl: string;

    constructor(
        private readonly $scope: IScope,
        private readonly $window: IWindowService,
        private readonly config: IConfig,
    ) {}

    public $onInit(): void {
        switch (this.config.environment) {
            case "dev":
                this.customerAppUrl = "https://irdevcustomerapp.z16.web.core.windows.net/";
                break;
            case "test":
                this.customerAppUrl = "https://irtestcustomerapp.azureedge.net/";
                break;
            case "prod":
                this.customerAppUrl = "https://app.irisity.com/";
                break;
            default:
                this.customerAppUrl = "https://app.irisity.com/";
        }
    }

    public continueToApp(): void {
        this.$window.location.replace(this.customerAppUrl);
    }

    public stayHere(): void {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }
}
